import { size } from '@styles/theme'

import { LookingStatusProfileFormButton } from './LookingStatusProfileFormButton'
import { FormTextField } from '@elements/Inputs'
import { Section } from './SharedFormComponents'

const NearbyGeneralFormSection = ({ state, handleExtendedChange }) => {
  return (
    <Section style={{ gap: size(3) }}>
      <FormTextField
        name='tagline'
        label='Tagline'
        maxlength='200'
        placeholder='Tell others what you want to do.'
        value={state?.tagline}
        onChange={handleExtendedChange}
        style={{ marginBottom: 0 }}
        multiline
        rows={3}
      />
      <LookingStatusProfileFormButton
        tagline={state?.tagline}
      />
    </Section>
  )
}

export { NearbyGeneralFormSection }
